<template>
<div v-if="selectedGroup">
    <BreadCrumbList>
      <span>{{this.selectedGroupName}}</span>
      <span>{{this.$t("app.dashboard.sidemenu.setting")}}</span>
    </BreadCrumbList>
    <div v-if="isOwned" class="card">
        <div class="card-content">
            <h3 style="padding:10px">{{$t('app.dashboard.settings.groupname')}}</h3>
            <div class="level">
                <div v-if="isFirefox">
                    <b-input ref="target" v-model="newGroupName"  maxlength="16" required :pattern="pattern"></b-input>
                    <font size="1">{{$t('app.dashboard.validation_message')}}</font>
                </div>
                <div v-else>
                    <b-input ref="target" v-model="newGroupName" maxlength="16" required :pattern="pattern"></b-input>
                    <font size="1">{{$t('app.dashboard.validation_message')}}</font>
                </div>
                <b-button :disabled="!validation" @click="changeGroupName" class="button is-danger">{{$t("app.dashboard.settings.modify")}}</b-button>
            </div>
            <hr>
            <div class="level">
                <h3>{{$t("app.dashboard.settings.publish")}}
                    <span v-if="this.selectedGroupPublic == true">{{$t('app.dashboard.settings.allow')}}</span>
                    <span v-else>{{$t('app.dashboard.settings.forbid')}}</span>
                </h3>
                <b-field class="level-right">
                    <b-select v-model="isPublic" :placeholder="$t('app.dashboard.settings.plh')">
                        <option value=true>{{$t('app.dashboard.settings.allow')}}</option>
                        <option value=false>{{$t('app.dashboard.settings.forbid')}}</option>
                    </b-select>
                    <b-button @click="changeGroupState" type="is-danger">
                        {{$t("app.dashboard.settings.modify")}}
                    </b-button>
                </b-field>
            </div> 
        </div>
    </div>
    <div class="card">
        <div class="card-content">
            <div v-if="isOwned" class="level">
                <h3>{{$t("app.dashboard.settings.delete")}}</h3>
                <b-button @click="onConfirmDelete" class="button is-danger">{{$t("general.delete")}}</b-button>
            </div>
            <div v-else class="level">
                <h3>{{$t("app.dashboard.settings.leave")}}</h3>
                <b-button @click="onConfirmLeave" class="button is-danger">{{$t("app.dashboard.settings.exit")}}</b-button>
            </div>
        </div>
    </div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
</div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import GroupSelectHandler from './GroupSelectHandler'
import BreadCrumbList from '../../../view/BreadCrumbList'

export default GroupSelectHandler.extend({
    components: {BreadCrumbList},
    data() {
        return {
            newGroupName: null,
            isPublic: this.selectedGroupPublic,
            isLoading: false,
            isSideActive: this.$store.state.dashboard.options.isSideActive,
            isFirefox: window.navigator.userAgent.includes("Firefox"),
            pattern: this.isFirefox? "^[A-Za-z0-9-_@\\/][A-Za-z0-9-_@ \\/]*$" : "^[0-9-_@\\/\\p{General_Category=Letter}\\p{Emoji}][0-9-_@ \\/\\p{General_Category=Letter}\\p{Emoji}]*$", // 先頭文字はSpace除く
        }
    },
    mounted() {
        if (this.selectedGroup) {
            this.newGroupName = this.selectedGroupName
            this.isPublic = this.selectedGroupPublic
        }
        this.$store.watch(
            state => state.groups.selected, 
            () => {
                this.newGroupName = this.selectedGroupName
                this.isPublic = this.selectedGroupPublic
            }
        )
    },
    computed: {
        validation: function() {
            return RegExp(this.pattern, "u").test(this.newGroupName)
        },
        members: state => {
            if (state.groups.cached[state.groups.selected]) {
                return state.groups.cached[state.groups.selected].Members.map(i => {return {id: i.UserID, name: i.Name}})
            } else {
                return []
            }
        },
        ...mapState({
            'isOwned': state => state.groups.selected && state.groups.cached[state.groups.selected] && state.groups.cached[state.groups.selected].OwnerID === state.account.id,
            'selectedGroupName': state =>  state.groups.cached[state.groups.selected]  && state.groups.cached[state.groups.selected].Name,
            'selectedGroupPublic': state => state.groups.cached[state.groups.selected] && state.groups.cached[state.groups.selected].SharedState === "public",
            'members': state => {
                if (state.groups.cached[state.groups.selected]) {
                    return state.groups.cached[state.groups.selected].Members.map(i => {return {id: i.UserID, name: i.Name}})
                } else {
                    return []
                }
            }
        })
    },
    methods: {
        changeGroupName() {
            const judgeState = (s) => {
                if (s === this.selectedGroupPublic)
                    return undefined

                if (s == 'true'){
                    return 'public'
                }else if (s == 'false'){
                    return 'private'
                }
            }
            this.isLoading = true
            this.modifyGroup({
                gId: this.selectedGroup,
                name: (this.newGroupName != "")? this.newGroupName: undefined,
                state: judgeState(this.isPublic)
            })
            .then(() => {
                this.$buefy.toast.open({
                    duration: 2000,
                    message: this.$t("app.dashboard.group.modify.success"),
                    position: "is-top",
                    type: "is-success"
                })
                this.$router.push({path: `/dashboard/`}, () => {})
            })
            .catch(() => {
                this.$buefy.toast.open({
                    duration: 7000,
                    message: this.$t('app.dashboard.graph.error_warning'),
                    position: "is-top",
                    type: "is-danger"
                })
                return Promise.resolve()
            })
            .finally(() => {
                this.isLoading = false
                this.isSideActive = [1, 0, 0]
                this.$store.dispatch("UpdateisSideActive", this.isSideActive)
            })
        },
        changeGroupState() {
            const judgeState = (s) => {
                if (s === this.selectedGroupPublic)
                    return undefined

                if (s == 'true'){
                    return 'public'
                }else if (s == 'false'){
                    return 'private'
                }
            }
            this.isLoading = true
            this.modifyGroup({
                gId: this.selectedGroup,
                name: this.selectedGroupName,
                state: judgeState(this.isPublic)
            })
            .then(() => {
                this.$buefy.toast.open({
                    duration: 2000,
                    message: this.$t("app.dashboard.group.modify.success2"),
                    position: "is-top",
                    type: "is-success"
                })
                this.$router.push({path: `/dashboard/`}, () => {})
            })
            .catch(() => {
                this.$buefy.toast.open({
                    duration: 7000,
                    message: this.$t('app.dashboard.graph.error_warning'),
                    position: "is-top",
                    type: "is-danger"
                })
                return Promise.resolve()
            })
            .finally(() => {
                this.isLoading = false
                this.isSideActive = [1, 0, 0]
                this.$store.dispatch("UpdateisSideActive", this.isSideActive)
            })
        },
        onConfirmDelete() {
            this.$buefy.dialog.confirm({
                title: this.members.length >= 2 ? this.$t("app.dashboard.group.disband.title") : this.$t("app.dashboard.group.disband.title"),
                message: this.members.length >= 2 ? this.$t("app.dashboard.group.disband.message_multi") : this.$t("app.dashboard.group.disband.message"),
                confirmText: this.$t("app.dashboard.group.disband.confirm"),
                cancelText: this.$t("app.dashboard.group.disband.cancel"),
                type: 'is-danger',
                hasIcon: true,
                onConfirm: async () => {
                    this.isLoading = true
                    await this.deleteGroup(this.selectedGroup)
                    .then(() => this.unselectGroup)
                    .then(() => this.$buefy.toast.open({
                        duration: 2000,
                        message: this.$t("app.dashboard.group.disband.success"),
                        position: "is-top",
                        type: "is-success"
                    }))
                    .catch(() => {
                        this.$buefy.toast.open({
                            duration: 7000,
                            message: this.$t('app.dashboard.graph.error_warning'),
                            position: "is-top",
                            type: "is-danger"
                        })
                        return Promise.resolve()
                    })
                    .finally(() => this.isLoading = false)
                    await this.$router.push({path: `/dashboard/`}, () => {})
                }
            })
        },
        onConfirmLeave() {
            this.$buefy.dialog.confirm({
                title: this.$t("app.dashboard.group.leave.title"),
                message: this.$t("app.dashboard.group.leave.message"),
                confirmText: this.$t("app.dashboard.group.leave.confirm"),
                cancelText: this.$t("app.dashboard.group.leave.cancel"),
                type: 'is-danger',
                hasIcon: true,
                onConfirm: async () => {
                    this.isLoading = true
                    await this.leaveGroup(this.selectedGroup)
                    .then(() => this.$buefy.toast.open({
                        duration: 2000,
                        message: this.$t("app.dashboard.group.leave.success"),
                        position: "is-top",
                        type: "is-success"
                    }))
                    .catch(() => {
                        this.$buefy.toast.open({
                            duration: 7000,
                            message: this.$t('app.dashboard.graph.error_warning'),
                            position: "is-top",
                            type: "is-danger"
                        })
                        return Promise.resolve()
                    })
                    .finally(() => this.isLoading = false)

                    await this.$router.push({path: `/dashboard/`}, () => {})
                }
            })
        },
        ...mapActions({
            'unselectGroup': 'groups/unselectGroup',
            'modifyGroup': 'groups/modifyGroup',
            'deleteGroup': 'groups/deleteGroup',
            'leaveGroup': 'groups/leaveGroup',
            'UpdateisSideActive': 'dashboard/UpdateisSideActive'
        })
    },
})
</script>

<style scoped>
.card {
    margin-top: 20px;
}
</style>
